import { render } from "./OnlineIncome.vue?vue&type=template&id=315b514e"
import script from "./OnlineIncome.vue?vue&type=script&lang=js"
export * from "./OnlineIncome.vue?vue&type=script&lang=js"

import "./OnlineIncome.vue?vue&type=style&index=0&id=315b514e&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__